import $ from 'jquery';
import { getTracker } from 'zoomforth_codesbane_viewer/lib/global_store.js';
import {
  stripParamsAndReplaceState
 } from 'zoomforth_zfutils/history_utils.js';

import {
  APP_CONTAINER_SELECTOR
} from 'zoomforth_codesbane_viewer/const/dom_selectors.js';

/**
  Setup page to attempt to fire unload event
*/
export const setupUnload = ()=> {

  const unload = function() {
    getTracker().handlePageUnload();
  };
  
  var hasUnloaded = false; 
  $(window).on('beforeunload', function() {
    hasUnloaded = true;
    unload();
  });
  $(window).on('unload', function() {
    if (!hasUnloaded) {
      unload();
    }
  });
};

export const setupAppContainerLayoutClassName = (shouldRenderAsMobile)=> {
  if (shouldRenderAsMobile) {
    $(APP_CONTAINER_SELECTOR).addClass('is-mobile-layout');    
  } else {
    $(APP_CONTAINER_SELECTOR).addClass('is-desktop-layout');
  }
};

export const setupAppContainerTranslationClassName = (currentLanguageIso)=> {
  $(APP_CONTAINER_SELECTOR).attr('class', function(i, c){
    return c.replace(/(^|\s)translation-mode-\S+/g, '');
  });

  $(APP_CONTAINER_SELECTOR).addClass(`translation-mode-${currentLanguageIso}`);    
};

export const setupCorrectPageUrl = ()=> {
  stripParamsAndReplaceState(window, [
    'auth',
    'ott',
    'pw_token',
    'saml_otp', // saml page access one time password
    'au_otp' // page_accessor app user page access one time password
  ]);
};
